import React, { CSSProperties, FC, ReactNode } from 'react';

import * as S from './styled';

export type CardProps = {
  title: string | ReactNode;
  indicators: any;
  minWidth?: number;
  height?: string | number;
  noPadding?: boolean;
  titlePadding?: boolean;
}

const Card: FC<CardProps> = ({ title, indicators, minWidth, height, noPadding, titlePadding }) => {
  const style: CSSProperties = { minWidth, height, position: 'relative' };
  const titleStyle: CSSProperties = {};

  if (noPadding) {
    style.padding = 0;
  }

  if (titlePadding) {
    titleStyle.padding = '16px 16px 0';
  }

  return (
    <S.Wrapper style={style}>
      <S.Title style={titleStyle}>{title}</S.Title>

      <S.SubWrapper>
        {indicators.map((indicator, key) => (
          <S.Indicator key={key} style={{ width: indicator.width }}>
            <S.IndicatorValues>{indicator.values}</S.IndicatorValues>
            <S.IndicatorLabels>{indicator.labels}</S.IndicatorLabels>
          </S.Indicator>
        ))}
      </S.SubWrapper>
    </S.Wrapper>
  );
};

export default Card;
